import { all, takeLatest } from "redux-saga/effects";
import { actionTypes } from "./reducer";
import { login as loginService, logout as logoutService, forgot as forgotService } from "./service";
import processAction from "../../utils/processAction";

function* login({ body }) {
  yield processAction({
    params: { body },
    service: loginService,
    success: actionTypes.LOGIN_SUCCESS,
    failed: actionTypes.LOGIN_FAILED
  });
}

function* logout({ id }) {
  yield processAction({
    params: { id },
    service: logoutService,
    success: actionTypes.LOGOUT_SUCCESS,
    failed: actionTypes.LOGOUT_FAILED
  });
}

function* forgot({ body }) {
  yield processAction({
    params: { body },
    service: forgotService,
    success: actionTypes.FORGOT_PASSWORD_SUCCESS,
    failed: actionTypes.FORGOT_PASSWORD_FAILED
  });
}

function* watchAuthRequests() {
  yield all([
    takeLatest(actionTypes.LOGIN_REQUEST, login),
    takeLatest(actionTypes.LOGOUT_REQUEST, logout),
    takeLatest(actionTypes.FORGOT_PASSWORD, forgot)
  ]);
}

export default [watchAuthRequests()];



// WEBPACK FOOTER //
// ./src/modules/auth/saga.js